const state = {
  orderBy: 'position',
  orderDirection: 'asc',
};

const getters = {
  orderBy: ({orderBy}) => orderBy,
  orderDirection: ({orderDirection}) => orderDirection,
};

const actions = {
  setOrderBy: ({commit}, orderBy) => commit('setOrderBy', orderBy),
};

const mutations = {
  setOrderBy(state, orderBy) {
    if (orderBy === state.orderBy) {
      state.orderDirection = state.orderDirection === 'asc' ? 'desc' : 'asc';
      return;
    }
    state.orderBy = orderBy;
    state.orderDirection = 'desc';
  },
};

const keywordSuggestions = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default keywordSuggestions;
